<template>
  <v-card class="edit-area" height="100%" v-show="editTarget">
    <v-card-text
      class="eidt-block html-edit h-100-pct"
      v-if="['Html'].includes(editTarget.format)"
    >
      <Trumbowyg
        v-model="editTarget.content"
        :config="config"
        class="form-control h-250-calc-vh"
      ></Trumbowyg>
    </v-card-text>

    <v-card-text
      class="eidt-block panel-edit h-100-pct"
      v-if="['Panel'].includes(editTarget.format)"
    >
      <vue-json-editor
        v-model="editTarget.content"
        lang="zh"
        :mode="'code'"
        :show-btns="false"
        :expandedOnStart="true"
      ></vue-json-editor>
      <v-expansion-panels>
        <v-expansion-panel v-for="(item, i) in editTarget.content" :key="i">
          <v-expansion-panel-header
            ><v-text-field
              v-model="item.title"
              label="輸入標題"
              hide-details=""
            ></v-text-field
          ></v-expansion-panel-header>
          <v-expansion-panel-content>
            <Trumbowyg
              v-model="item.text"
              :config="config"
              class="form-control h-250-calc-vh"
            ></Trumbowyg>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-card-text>
    <v-card-actions
      v-if="editTarget.format"
      class="actions-block w-100-pct white"
    >
      <v-btn plain @click.stop="save()">更新</v-btn>
      <v-btn plain @click.stop="cancel()">取消</v-btn>
      <v-spacer></v-spacer>
      <v-btn v-if="editTarget.ctxId" plain @click.stop="turn()">{{
        editTarget.flag === 1 ? '停用' : '啟用'
      }}</v-btn>
      <v-btn v-if="editTarget.ctxId" plain @click.stop="deleteBtn()"
        >刪除</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import vueJsonEditor from 'vue-json-editor'

import 'jquery-ui-dist/jquery-ui'
import 'jquery-ui-dist/jquery-ui.min.css'
import 'jquery-resizable-dom/dist/jquery-resizable'

import Trumbowyg from 'vue-trumbowyg'
import 'trumbowyg/dist/ui/trumbowyg.css'
import 'prismjs/themes/prism.css'
import 'trumbowyg/dist/plugins/highlight/ui/trumbowyg.highlight.min.css'
import 'trumbowyg/dist/plugins/emoji/ui/trumbowyg.emoji.min.css'
import 'trumbowyg/dist/plugins/colors/ui/trumbowyg.colors.min.css'
import 'trumbowyg/dist/plugins/specialchars/ui/trumbowyg.specialchars.min.css'
// import 'trumbowyg/dist/plugins/table/ui/trumbowyg.table.min.css'

import 'prismjs'
import 'trumbowyg/dist/plugins/highlight/trumbowyg.highlight.min.js'
import 'prismjs/components/prism-php'
import 'trumbowyg/dist/plugins/preformatted/trumbowyg.preformatted.min.js'
import 'trumbowyg/dist/plugins/fontsize/trumbowyg.fontsize.min.js'
import 'trumbowyg/dist/plugins/emoji/trumbowyg.emoji.min.js'
import 'trumbowyg/dist/plugins/colors/trumbowyg.colors.min.js'
import 'trumbowyg/dist/plugins/indent/trumbowyg.indent.min.js'
import 'trumbowyg/dist/plugins/lineheight/trumbowyg.lineheight.min.js'
import 'trumbowyg/dist/plugins/resizimg/trumbowyg.resizimg.min.js'
import 'trumbowyg/dist/plugins/specialchars/trumbowyg.specialchars.min.js'
// import 'trumbowyg/dist/plugins/table/trumbowyg.table.min.js'

export default {
  name: 'ContentEdit',

  components: { Trumbowyg, vueJsonEditor },

  data() {
    return {
      editeClassList: [
        { text: '文字', icon: 'mdi-format-text', key: 'Html' },
        { text: '手風琴樣式', icon: 'mdi-server', key: 'Panel' }
      ],
      editedList: [],
      config: {
        // autogrowOnEnter: true,
        btns: [
          [
            'fontsize',
            'foreColor',
            'backColor',
            'strong',
            'em',
            'del',
            'lineheight'
          ],
          ['preformatted'],
          ['superscript', 'subscript'],
          ['specialChars', 'emoji', 'link', 'insertImage'],
          ['indent', 'outdent'],
          ['justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull'],
          ['unorderedList', 'orderedList'],
          ['horizontalRule'],
          ['viewHTML'],
          ['removeformat']
        ],
        plugins: {
          resizimg: {
            minSize: 64,
            step: 16
          }
        }
      },
      countentsFromDBRaw: {}
    }
  },

  computed: {
    ...mapState('common', ['modifyMode']),
    ...mapState('document', ['countentsFromDB', 'currEditObj', 'createMode']),
    editTarget() {
      let data = {}
      if (this.createMode === 1) {
        data = this.currEditObj
      } else if (this.createMode === 0) {
        data = this.countentsFromDB.leaf.find((e) => {
          return e.ctxId === this.currEditObj.ctxId
        })
      }
      if (data.format === 'Panel' && data.content === '') {
        data.content = [
          {
            title: '',
            text: ''
          }
        ]
      }
      return data
    }
  },

  watch: {
    createMode(newVal) {
      if (newVal !== -1) {
        this.countentsFromDBRaw = JSON.parse(
          JSON.stringify(this.countentsFromDB)
        )
      }
    }
  },

  mounted() {
    window.addEventListener('storage', (e) => {
      if (e.key && e.key === 'editedContent' && e.newValue) {
        this.editedList = JSON.parse(e.newValue)
      }
    })
  },

  methods: {
    ...mapMutations('document', ['SET_CURRENTCONTENT']),
    ...mapActions('document', ['setCreateMode', 'setCurrentContent']),
    ...mapActions('message', ['setSnackbar']),
    turn() {
      const data = {
        ctxId: this.currEditObj.ctxId,
        flag: this.currEditObj.flag === 1 ? 0 : 1
      }
      this.$api.common.leaf.turn(data).then((res) => {
        this.setInit()
      })
    },
    deleteBtn() {
      const curr = this.editTarget
      const data = {
        ctxId: curr.ctxId
      }
      this.$api.common.leaf.deleteContent(data).then((res) => {
        this.setInit()
      })
    },
    save() {
      const curr = this.editTarget
      const data = {
        content:
          typeof curr.content === 'string'
            ? curr.content
            : JSON.stringify(curr.content),
        format: curr.format,
        parentId: curr.parentId,
        sn: curr.sn
      }

      if (data.content === '') {
        this.setSnackbar({
          show: true,
          text: '內容不可為空。',
          type: 'text',
          timeout: '1200'
        })
        this.cancel()
        return
      }
      if (curr.ctxId) {
        data.ctxId = curr.ctxId
        this.$api.common.leaf.setContent(data).then((res) => {
          this.setInit()
        })
      } else {
        this.$api.common.leaf.createContent(data).then((res) => {
          this.setInit()
        })
      }
    },
    cancel() {
      this.SET_CURRENTCONTENT(this.countentsFromDBRaw)
      this.setCreateMode({ obj: {}, mode: -1 })
      this.countentsFromDBRaw = {}
    },
    setInit() {
      this.setCreateMode({ obj: {}, mode: -1 })
      const menuId = this.$router.currentRoute.query.menuId
      this.$api.common.leaf.getCtxesByMenuId4All(menuId).then((res) => {
        this.setCurrentContent(res)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.edit-area {
  overflow: hidden;
}
.eidt-block {
  overflow-y: auto;
  padding-bottom: 60px;
}
.v-card__actions {
  position: absolute;
  bottom: 0;
  z-index: 1;
}

.jsoneditor-vue {
  height: 100%;
}
</style>
